
<script>

import gsap from "gsap"

export default {

  name: 'SingleLine',
  render: h => h(),
  props: ['specs'],
  data:()=>({
    step: 0,
    count:0,
    hv: 0
  }),
  mounted() {

    console.log('SingleLine');


    console.log(this.specs);

    // this.$store.commit('app/UPDATE_LINE', 0)
    this.$scene = this.$parent.scene

    this.addLine()
   
    // this.resetPoints() 

  },

  methods:{

    // resetPoints() {
    //   this.$points = []
    //   this.$points[0] = []
    //   this.$points[1] = []
    //   this.$points[2] = []
    // },

    // eraseSingleLine() {
    //   this.$parent.cues = []
    //   this.clearAllHelpers(this.$scene)
    // },

    // clearAllHelpers(scene) {
    //   this.resetPoints()
    //   for (let i = 0; i < this.max; i++) {
    //     if(this['$tube_'+ i])
    //       scene.remove(this['$tube_'+ i])
    //   }
    // },

    // eraseLine() {
    //   this.$parent.cues = []
    //   this.clearHelpers(this.$scene)
    // },

    update(time, spikes, _analyser, _duration ){
      const analyser = _analyser ? _analyser : 0
      const duration = _duration ? _duration : 0
      if(this.count%10 == 0){
        this.step += 1
        if(this.step >=10) this.step = 0
        this.hv = analyser*(3+(this.specs.pos*2))
        this.addLine()
      }
      this.count += 1
    },
    
    addLine() {
  
      this.$points = []
      this.$cues = []
      if(this.$tube)
        this.$scene.remove(this.$tube)
      
      for(let i=0; i<20; i++){

        const obj = {}
              obj.x = (i*5)-40

            if(this.specs.pos + this.step == i
            || this.specs.pos + 18 + this.step == i)
              obj.y = -this.hv+(this.specs.pos)

            else if(this.specs.pos + 6 + this.step == i
                || this.specs.pos + 6 + this.step == i)
              obj.y = this.hv+(this.specs.pos)
            else 
              obj.y = this.specs.pos

            obj.z = 0

        this.$cues.push(obj)
      }

      _.each(this.$cues, (p, i)=>{
        this.$points.push(new THREE.Vector3(p.x, p.y, p.z))
      })

      this.onAddLine()
    },

    onAddLine() {

      const positions = []
      const colors = []
      const spline = new THREE.CatmullRomCurve3( this.$points )
      const divisions = Math.round( 20 * this.$points.length )
      const point = new THREE.Vector3()
      const color = new THREE.Color()

      this.$divisions = divisions

      for ( let i = 0, l = divisions; i < l; i ++ ) {
        const t = i / l
        spline.getPoint( t, point )
        positions.push( point.x, point.y, point.z )
      }

      const geometry = new THREE.LineGeometry()
            geometry.setPositions( positions )

      let matLine = new THREE.LineMaterial( {
        wireframe: false,
        color: Number(this.specs.color),
        linewidth: .0035,
        // toneMapped: false
      })

      this.$tube = new THREE.Line2( geometry, matLine )
      this.$tube.computeLineDistances()
      this.$tube.scale.set( 1, 1, 1 )
      this.$scene.add(this.$tube)

    },
  }

}
</script>

<style lang="stylus">


